import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import WbCloudyOutlinedIcon from '@mui/icons-material/WbCloudyOutlined';
import StorageIcon from '@mui/icons-material/Storage';

const Proteus = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <WbCloudyOutlinedIcon /> Connect Data Provider
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Connect Salesforce, Azure Cosmos, Google Firestore or AWS DynamoDB as data sources.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Connect Provider
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <AutoStoriesOutlinedIcon /> Object Types
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Define and manage object types used across Olympus-Grid and external systems.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage Types
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <StorageIcon /> Object Browser
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Browse, query and manage live data records from all connected systems.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Open Browser
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Proteus;